// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import SendIcon from '@mui/icons-material/Send';
import TextField from '@mui/material/TextField';
import PropTypes from 'prop-types';


export default function OCRTextDialog(props) {

  const { open , onSelect } = props;

  const ocrText = props.ocrText || "";
  const onClose = props.onClose;
  const options = props.options || [];

  // console.log("OCRTextDialog options", options);

  // console.log("ocrText", ocrText);

  const [editText, setEditText] = useState("");

  useEffect(() => {
    setEditText(ocrText);
  }, [ocrText]);
  


  const handleTextChange = (event) => {
    setEditText(event.target.value);
  }

  const handleCloseClick = () => {
    onClose && onClose();
  }

  const handleClick = (e, aLabel) => {
    // console.log("handleClick", e);
    onSelect && onSelect(aLabel, editText);
  }

  return (
    <Dialog
      open={open}
      onClose={handleCloseClick}
      fullWidth={true}
      // minWidth={"lg"}
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        OCR Text
        
      </DialogTitle>
      <DialogContent>
        <TextField id="edit-text" label="" value={editText} onChange={handleTextChange} fullWidth />

        <List>

          {options.map(o => {
            return (
              <ListItemButton key={o.label} onClick={(e) => handleClick(e, o.label)} >
                <ListItemIcon>
                  <SendIcon />
                </ListItemIcon>
                <ListItemText primary={`Fill to [${o.label}]`} />
              </ListItemButton>
            )
          })}

        </List>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseClick}>Close</Button>
      </DialogActions>
    </Dialog>

  );
}

OCRTextDialog.propTypes = {
  open: PropTypes.bool,
  ocrText: PropTypes.string,
  options: PropTypes.array,
  onClose: PropTypes.func,
  onSelect: PropTypes.func,
};
